import { APP_ID, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APIHttpInterceptor } from './shared/services/interceptors/http.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { CookieModule, CookieService } from 'ngx-cookie';
import { ErrorHandler } from './shared/services/interceptors/error_handler';
import { AuthGuard } from './shared/services/auth/auth.guard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RootService } from './shared/services/auth/root.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CookieService } from './shared/services/api-integration-files/cookie.service';
import { VideoModalModule } from './shared/video-modal/video-modal.module';
import { RoleGuard } from './shared/services/auth/role.guard';
// import { APP_BASE_HREF } from '@angular/common';
export function init_app(
  rootService: RootService,
) {
  return () => rootService.upgradeVersion();
  // return () => rootService.getFreeSearchToken();

}
@NgModule({ declarations: [
        AppComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        // CookieModule.forRoot(),
        BrowserAnimationsModule, MatSnackBarModule,
        NgxSpinnerModule,
        VideoModalModule], providers: [
        // BrowserModule.withServerTransition({ appId: 'serverApp' }) was
        // removed at Angular 19; APP_ID is the direct replacement.
        { provide: APP_ID, useValue: 'serverApp' },
        AuthGuard, RoleGuard,
        ErrorHandler,
        { provide: HTTP_INTERCEPTORS,
            useClass: APIHttpInterceptor,
            multi: true,
        },
        // { provide: HTTP_INTERCEPTORS, useClass: ErrorHandler, multi: true },
        {
            provide: APP_INITIALIZER,
            useFactory: init_app,
            deps: [RootService,
                //ssrcookie
                CookieService
            ],
            multi: true
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        // Reuse the server-rendered DOM instead of discarding and rebuilding
        // it (no flash, lower LCP/CLS). Components that change their DOM
        // outside Angular (Owl Carousel, browser-only data) opt out with
        // ngSkipHydration on their host. withEventReplay replays clicks made
        // before the bundle finished booting.
        provideClientHydration(withEventReplay()),
    ] })
export class AppModule { }
